//
// エラーハンドラ
//
function defaultHandler (errs) {
  console.error(errs)
}

var errorHandler = defaultHandler

export function setHandler (handler) {
  errorHandler = handler || defaultHandler
}

export function post (errs) {
  errorHandler(errs)
}
